import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Message } from 'semantic-ui-react';
import ErrorMessage from '../ErrorMessage';

function LoginVerificationMessage({ verificationStatus }) {
  const { fetching, error, loginName, loginVerified } = verificationStatus;
  if (fetching) {
    // loading message
    return (
      <Message icon info>
        <Icon name="circle notched" loading />
        <Message.Content>
          <Message.Header>Verifying Login...</Message.Header>
        </Message.Content>
      </Message>
    );
  }
  if (error) {
    // error message
    return <ErrorMessage error={error} />;
  }
  if (loginName) {
    // validation result message
    return (
      <Message icon positive={loginVerified} negative={!loginVerified}>
        <Icon name={loginVerified ? 'check circle' : 'exclamation circle'} />
        <Message.Content>
          <Message.Header>
            Login &apos;{loginName}&apos;
            {loginVerified
              ? ' successfully authenticated.'
              : ' failed to authenticate.'}
          </Message.Header>
        </Message.Content>
      </Message>
    );
  }
  return null;
}

LoginVerificationMessage.propTypes = {
  verificationStatus: PropTypes.object,
};

export default LoginVerificationMessage;
